// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RegressionLine.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import { CHART_SETTINGS } from 'logic/data/Izenda.ReportPartChartConstants';

const {
  REGRESSION_TYPE_OPTIONS,
  REGRESSION_POLYNOMIAL_ORDER,
  DEFAULT_VALUE,
  REGRESSION_LINEAR_DECIMAL_PLACES_DEFAULT_VALUE
} = CHART_SETTINGS;

export default class RegressionLine {
  @observable hideInLegend: boolean;
  @observable type: string;
  @observable order: string;
  @observable lineWidth: string;
  @observable dashStyle: string;
  @observable color: string;
  @observable visible: boolean;
  @observable field: any;
  @observable extrapolate: number;
  @observable decimalPlaces: number;
  @observable name: string;
  @observable activeSeriesKey: string;

  /**
   * Read data
   */
  @action
  readData(regressionSetting: any) {
    const {
      visible = true,
      hideInLegend = false,
      type = REGRESSION_TYPE_OPTIONS[0].value,
      order = REGRESSION_POLYNOMIAL_ORDER[0].value,
      lineWidth = DEFAULT_VALUE.WIDTH,
      dashStyle = DEFAULT_VALUE.DASH_STYLE,
      color = DEFAULT_VALUE.BLACK_COLOR,
      extrapolate = null,
      name = '',
      decimalPlaces = REGRESSION_LINEAR_DECIMAL_PLACES_DEFAULT_VALUE
    } = regressionSetting || {};

    this.name = name;
    this.visible = visible;
    this.hideInLegend = hideInLegend;
    this.type = type;
    this.order = order;
    this.lineWidth = lineWidth;
    this.dashStyle = dashStyle;
    this.color = color;
    this.extrapolate = extrapolate;
    this.decimalPlaces = decimalPlaces;
  }

  /**
   * Update value
   */
  @action
  updateValue(key: string, value: any) {
    this[key] = value;
  }
}


// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.RegressionLine.js